/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PromotionsLayout_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SessionLayout_viewer">;
    readonly " $refType": "PromotionsLayout_viewer";
};
export type PromotionsLayout_viewer$data = PromotionsLayout_viewer;
export type PromotionsLayout_viewer$key = {
    readonly " $data"?: PromotionsLayout_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PromotionsLayout_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PromotionsLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SessionLayout_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'b59fa3a7351fbcb755db64c07669c783';
export default node;
